import { render, staticRenderFns } from "./ModalVariants.vue?vue&type=template&id=094316f2"
import script from "./ModalVariants.vue?vue&type=script&lang=js"
export * from "./ModalVariants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports